import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import NationalLanding from "./pages/NationalLanding";
import { PaymentSuccess } from "./pages/PaymentResult";
import { BookedRelay } from "./pages/BookedRelay";
import { PrivacyPolicy, TermsOfService } from "./pages/LegalPages";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NationalLanding />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/booked" element={<BookedRelay />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/:slug" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
